<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{pageData.MenuName}}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>程式代碼</td>
                  <td>
                    <input
                      type="text"
                      v-model="form.PRGCODE"
                      size="20"
                      maxlength="20"
                    />
                  </td>
                  <td>程式名稱</td>
                  <td>
                    <input
                      type="text"
                      v-model="form.PRGNAME"
                      size="50"
                      maxlength="50"
                    />
                  </td>
                </tr>
                <tr>
                  <td>排程名稱</td>
                  <td colspan="3">
                    <p>
                      <input
                        type="text"
                        v-model="form.BATNM"
                        size="20"
                        maxlength="20"
                      />
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>啟用註記</td>
                  <td colspan="3">
                    <p>
                      <label>
                        <input type="radio" v-model="form.STATUS" value="Y" />
                        啟用
                      </label>
                      <label>
                        <input type="radio" v-model="form.STATUS" value="N" />
                        停用
                      </label>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="btnQuery()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="新增"
                          @click="btnBattModal()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnFormClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid && grid.paginaiton">
            <tbody>
              <tr>
                <td align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th colspan="3">操作</th>
                    <th>排程序號</th>
                    <th>排程名稱</th>
                    <th>執行程式名稱</th>
                    <th>執行週期類別</th>
                    <th>預定執行日期時間</th>
                    <th>啟用註記</th>
                  </tr>
                </thead>
                <tbody v-if="grid && grid.gridDatas && grid.gridDatas.length">
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <!-- onclick="alert('是否立即執行排程?')"
                      <input type="button" class="btn" value="執行" disabled /> -->
                      <input
                        type="button"
                        class="btn"
                        value="執行"
                        @click="btnRun(data)"
                      />
                    </td>
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="編"
                        @click="btnEditBattModal(data)"
                      />
                    </td>
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="刪"
                        @click="btnModalDelete(data)"
                      />
                    </td>
                    <td>{{ data.batid }}</td>
                    <td>{{ data.batnm }}</td>
                    <td>{{ data.prgname }}</td>
                    <td>{{ data.cycletypetxt }}</td>
                    <td>{{ data.schadddtime }}</td>
                    <td>{{ data.status }}</td>
                  </tr>
                </tbody>
                <tbody v-else-if="grid.paginaiton">
                  <tr>
                    <td colspan="9" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <BattModal
      v-model="BattModal.show"
      :title="BattModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td size="20">排程名稱</td>
                <td>
                  <input
                    type="text"
                    v-model="BattModal.form.BATNM"
                    size="20"
                    maxlength="20"
                  />
                </td>
              </tr>
              <tr>
                <td>執行程式代碼</td>
                <td colspan="4">
                  <input
                    type="text"
                    v-model="BattModal.form.PRGCODE"
                    size="50"
                    maxlength="100"
                  />
                </td>
              </tr>
              <tr>
                <td>執行程式名稱</td>
                <td colspan="4">
                  <input
                    type="text"
                    v-model="BattModal.form.PRGNAME"
                    size="50"
                    maxlength="100"
                  />
                </td>
              </tr>
              <tr>
                <td>預定執行日期時間</td>
                <td>
                  <DatePicker
                    v-model="BattModal.form.SCHADDDTIME"
                    format="YYYYMMDD HH:mm:ss"
                    :isTaiwanYear="false"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
                <td>執行週期類別</td>
                <td>
                  <select v-model="BattModal.form.CYCLETYPE">
                    <option
                      v-for="item in BattModal.dropDownList.CYCLETYPEs"
                      :key="item.key"
                      :value="item.key"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                </td>
                <td>週期值</td>
                <td>
                  <input
                    type="text"
                    v-model.number="BattModal.form.CYCLEVAL"
                    size="5"
                    maxlength="5"
                  />
                </td>
              </tr>
              <tr>
                <td>啟用註記</td>
                <td colspan="3">
                  <p>
                    <label>
                      <input
                        type="radio"
                        v-model="BattModal.form.STATUS"
                        value="Y"
                      />
                      啟用
                    </label>
                    <label>
                      <input
                        type="radio"
                        v-model="BattModal.form.STATUS"
                        value="N"
                      />
                      停用
                    </label>
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        @click="btnBattModalSave()"
                        value="存檔"
                      />
                      <input
                        type="submit"
                        class="btn"
                        @click="btnBattModalClear()"
                        value="重填"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="執行參數設定"
                        @click="btnEditAddParaModel()"
                        v-show="BattModal.form.modifyType == 'U'"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
      <!-- 查詢結果開始-->
      <div class="information" v-show="BattModal.form.modifyType == 'U'">
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th colspan="2">操作</th>
                  <th>參數代碼</th>
                  <th>參數值</th>
                  <th>說明</th>
                </tr>
              </thead>
              <tbody
                v-if="
                  BattModal.grid &&
                  BattModal.grid.battParaViewModels &&
                  BattModal.grid.battParaViewModels.length
                "
              >
                <tr
                  v-for="(data, index) in BattModal.grid.battParaViewModels"
                  :key="index"
                >
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="編"
                      @click="btnShowParaModalEdit(data)"
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="刪"
                      @click="btnShowParaModalDelete(data)"
                    />
                  </td>
                  <td>{{ data.parakey }}</td>
                  <td>{{ data.paraval }}</td>
                  <td>{{ data.paradesc }}</td>
                </tr>
              </tbody>
              <tbody v-else-if="grid.paginaiton">
                <tr>
                  <td colspan="5" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </BattModal>

    <ParaModal
      v-model="ParaModal.show"
      :title="ParaModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>參數代碼</td>
                <td>
                  <input
                    type="text"
                    v-model="ParaModal.form.PARAKEY"
                    size="40"
                    maxlength="100"
                  />
                </td>
              </tr>
              <tr>
                <td>參數值</td>
                <td>
                  <input
                    type="text"
                    v-model="ParaModal.form.PARAVAL"
                    size="40"
                    maxlength="100"
                  />
                </td>
              </tr>
              <tr>
                <td>說明</td>
                <td>
                  <p>
                    <textarea
                      v-model="ParaModal.form.PARADESC"
                      style="width: 400px; height: 200px"
                      maxlength="400"
                    >
                    </textarea>
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="btnParaModalSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnParaModalClear()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </ParaModal>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <Confirm v-model="Confirm.show" :title="Confirm.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Confirm.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Confirm.BtnConfirm">確定</button>
          <button class="btn" @click="Confirm.show = false">取消</button>
        </div>
      </div>
    </Confirm>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import axioshttp from "@/config/httpConfig";
import { getMenuIndex,getMenu } from "@/config/util.js";
import {
  S701_SearchGrid,
  S701_SearchGridDetail,
  S701_ModifyGrid,
  S701_ModifyGridDetail,
  S701_BattRun
} from "@/service/api.js";
export default {
  name: "S701",
  data: function () {
    return {
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S701",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        PRGCODE: "",
        PRGNAME: "",
        BATNM: "",
        STATUS: "Y",
        currentpage: 1,
        pagesize: 10,
      },
      grid: {},
      BattModal: {
        show: false,
        title: "",
        PreData: {},
        form: {
          modifyType: "",
          PKNO: null,
          BATNM: "",
          PRGCODE: "",
          PRGNAME: "",
          CYCLETYPE: "1",
          CYCLEVAL: null,
          SCHADDDTIME: null,
          STATUS: "Y",
        },
        dropDownList: {
          CYCLETYPEs: [
            { key: "1", value: "每月" },
            { key: "2", value: "每週" },
            { key: "3", value: "每日" },
            { key: "4", value: "每小時" },
            { key: "5", value: "每分" },
          ],
        },
        grid: {},
      },
      ParaModal: {
        show: false,
        title: "",
        form: {
          modifyType: "",
          BATID: "",
          PKNO: null,
          PARAKEY: "",
          PARAVAL: "",
          PARADESC: "",
        },
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      Confirm: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    DatePicker: VueDatepicker,
    BattModal: VueModal,
    ParaModal: VueModal,
    Alert: VueModal,
    Confirm: VueModal,
  },
  methods: {
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁
    btnQuery: function () {
      const self = this;
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = self.form;
      postData.ServiceUnit = self.pageData.ServiceUnit;
      postData.LogInfo = {
        Id: self.loginInfo.id,
        PrgCode: self.pageData.PrgName,
        ActCd: "查詢",
        Token: self.loginInfo.token,
        ServiceUnit: self.pageData.ServiceUnit,
      };

      S701_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
        self.grid.gridDatas.forEach((x) => {
          x.schadddtime = self
            .$moment(x.schadddtime)
            .format("YYYYMMDD HH:mm:ss");
          x.cycletypetxt = self.BattModal.dropDownList.CYCLETYPEs.filter(
            (c) => c.key == x.cycletype
          )[0].value;
        });
      });
    },
    //重填
    btnFormClear: function () {
      this.form = {
        PRGCODE: "",
        PRGNAME: "",
        BATNM: "",
        STATUS: "Y",
        currentpage: 1,
        pagesize: 10,
      };
    },
    //新增系統排程頁面
    btnBattModal: function () {
      const self = this;
      self.BattModal.show = true;
      self.btnBattModalClear();
      self.BattModal.form.modifyType = "I";
      self.BattModal.title = "S701系統排程設定-新增";
    },
    //排程執行
    btnRun: function (data) {
      const self = this;
      //axioshttp.post("/api/v1/" + data.prgcode, "BackstageApi");
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: data.pkno,
      };
      postData.LogInfo = {
        Id: self.loginInfo.id,
        PrgCode: self.pageData.PrgName,
        ActCd: "執行",
        ServiceUnit: self.pageData.ServiceUnit,
        Token: self.loginInfo.token,
      };

      S701_BattRun(postData).then((rData) => {
        console.log(rData);
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = rData.messages;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      });

    },
    //編輯系統排程頁面
    btnEditBattModal: function (data) {
      const self = this;
      self.BattModal.show = true;
      self.BattModal.PreData = data;
      self.btnBattModalClear();
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: self.BattModal.PreData.pkno,
      };
      self.S701_SearchGridDetail(postData);
      self.BattModal.form.modifyType = "U";
      self.BattModal.title = "S701系統排程設定-編輯";
    },
    //刪除系統排程
    btnModalDelete: function (data) {
      const self = this;
      self.Confirm.show = true;
      self.Confirm.title = "提醒";
      self.Confirm.txt = ["請確定是否刪除??"];
      self.BattModal.form.modifyType = "D";
      self.Confirm.BtnConfirm = function () {
        let postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          ModifyType: self.BattModal.form.modifyType,
          PKNO: data.pkno,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "刪",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        self.S701_ModifyGrid(postData);
        self.Confirm.show = false;
      };
    },
    checkBattModalInputData: function () {
      const self = this;
      let msg = [];
      if (!self.BattModal.form.BATNM) {
        msg.push("請填寫執行排程名稱");
      }
      if (!self.BattModal.form.PRGCODE) {
        msg.push("請填寫執行程式代碼");
      }
      if (!self.BattModal.form.PRGNAME) {
        msg.push("請填寫執行程式名稱");
      }
      if (!self.BattModal.form.SCHADDDTIME) {
        msg.push("請填寫預定執行日期時間");
      } else if (
        self.$moment(self.BattModal.form.SCHADDDTIME).isBefore(new Date())
      ) {
        msg.push("預定執行日期時間需大於系統日");
      }
      if (!self.BattModal.form.CYCLETYPE) {
        msg.push("請填寫執行週期類別");
      }
      if (!self.BattModal.form.CYCLEVAL) {
        msg.push("請填寫週期值");
      } else if (isNaN(parseInt(self.BattModal.form.CYCLEVAL))) {
        msg.push("週期值請輸入整數");
      }
      if (!self.BattModal.form.STATUS) {
        msg.push("請填寫啟用註記");
      }
      return msg;
    },
    //存檔
    btnBattModalSave: function () {
      const self = this;
      let ErrMsg = self.checkBattModalInputData();
      if (ErrMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ErrMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
          //if(rData.result) self.btnQuery();
        };
      } else {
        let postData = self.BattModal.form;
        postData.ServiceUnit = self.pageData.ServiceUnit;
        self.S701_ModifyGrid(postData);
      }
    },
    btnBattModalClear: function () {
      this.BattModal.form = {
        modifyType: this.BattModal.form.modifyType,
        PKNO: this.BattModal.form.PKNO,
        BATNM: "",
        PRGCODE: "",
        PRGNAME: "",
        CYCLETYPE: "1",
        CYCLEVAL: null,
        SCHADDDTIME: null,
        STATUS: "Y",
      };
    },
    //設定參數
    btnEditAddParaModel: function () {
      const self = this;
      self.ParaModal.show = true;
      self.btnParaModalClear();
      self.ParaModal.form.modifyType = "I";
      self.ParaModal.form.BATID = self.BattModal.PreData.batid;
      self.ParaModal.title = "S701系統排程設定-參數設定";
    },
    btnShowParaModalEdit: function (data) {
      const self = this;
      self.ParaModal.show = true;
      self.ParaModal.form = {
        modifyType: "U",
        BATID: data.batid,
        PKNO: data.pkno,
        PARAKEY: data.parakey,
        PARAVAL: data.paraval,
        PARADESC: data.paradesc,
      };
      self.ParaModal.title = "S701系統排程設定-參數設定";
    },
    btnShowParaModalDelete: function (data) {
      const self = this;
      self.Confirm.show = true;
      self.Confirm.title = "提醒";
      self.Confirm.txt = ["請確定是否刪除??"];
      self.Confirm.BtnConfirm = function () {
        let postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          ModifyType: "D",
          PKNO: data.pkno,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁刪除",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        self.S701_ModifyGridDetail(postData);
        self.Confirm.show = false;
      };
    },
    checkParaInputData: function () {
      const self = this;
      let msg = [];
      if (!self.ParaModal.form.PARAKEY) {
        msg.push("請填寫參數代碼");
      }
      if (!self.ParaModal.form.PARAVAL) {
        msg.push("請填寫參數值");
      }
      return msg;
    },
    btnParaModalSave: function () {
      const self = this;
      let ErrorMsg = self.checkParaInputData();
      if (ErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ErrorMsg;
        self.Alert.BtnConfirm = function () {
          self.Alert.show = false;
        };
      } else {
        self.ParaModal.form.ServiceUnit = self.pageData.ServiceUnit;
        self.ParaModal.form.BATID = self.BattModal.PreData.batid;
        self.S701_ModifyGridDetail(self.ParaModal.form);
      }
    },
    btnParaModalClear: function () {
      const self = this;
      self.ParaModal.form = {
        modifyType: self.ParaModal.form.modifyType,
        BATID: self.ParaModal.form.BATID,
        PKNO: self.ParaModal.form.PKNO,
        PARAKEY: "",
        PARAVAL: "",
        PARADESC: "",
      };
    },
    //API
    S701_ModifyGrid: function (postData) {
      const self = this;
      postData.LogInfo = {
        Id: self.loginInfo.id,
        PrgCode: self.pageData.PrgName,
        ActCd: "第二頁存檔",
        ServiceUnit: self.pageData.ServiceUnit,
        Token: self.loginInfo.token,
      };
      S701_ModifyGrid(postData).then((rData) => {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = rData.messages;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
          if (rData.result) {
            if (self.BattModal.form.modifyType == "I") {
              self.BattModal.form.pkno = rData.returnObject.pkno;
              self.BattModal.PreData.pkno = rData.returnObject.pkno;
              self.BattModal.PreData.batid = rData.returnObject.batid;
              let postData = {
                ServiceUnit: self.pageData.ServiceUnit,
                pkno: self.BattModal.PreData.pkno,
              };
              self.BattModal.form.modifyType = "U";
              self.BattModal.title = "S701系統排程設定-編輯";
              self.S701_SearchGridDetail(postData);
            }
            self.btnQuery();
          }
        };
      });
    },
    S701_SearchGridDetail: function (postData) {
      const self = this;
      postData.LogInfo = {
        Id: self.loginInfo.id,
        PrgCode: self.pageData.PrgName,
        ActCd: "編",
        ServiceUnit: self.pageData.ServiceUnit,
        Token: self.loginInfo.token,
      };

      S701_SearchGridDetail(postData).then((rData) => {
        console.log(rData);
        const self = this;
        self.BattModal.grid = rData.returnObject;
        self.BattModal.form = {
          PKNO: self.BattModal.PreData.pkno,
          modifyType: self.BattModal.form.modifyType,
          BATNM: self.BattModal.grid.batnm,
          CYCLETYPE: self.BattModal.grid.cycletype,
          CYCLEVAL: self.BattModal.grid.cycleval,
          PRGCODE: self.BattModal.grid.prgcode,
          PRGNAME: self.BattModal.grid.prgname,
          SCHADDDTIME: self.BattModal.grid.schadddtime,
          STATUS: self.BattModal.grid.status,
        };
      });
    },
    S701_ModifyGridDetail: function (postData) {
      const self = this;
      postData.LogInfo = {
        Id: self.loginInfo.id,
        PrgCode: self.pageData.PrgName,
        ActCd: "第三頁存檔",
        ServiceUnit: self.pageData.ServiceUnit,
        Token: self.loginInfo.token,
      };
      S701_ModifyGridDetail(postData).then((rData) => {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = rData.messages;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
          if (rData.result) {
            let postData = {
              ServiceUnit: self.pageData.ServiceUnit,
              PKNO: self.BattModal.PreData.pkno,
            };
            self.S701_SearchGridDetail(postData);
            self.ParaModal.show = false;
          }
        };
      });
    },
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnQuery();
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if(Menu){
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
